export const LABELS = {
  COMPANY: "SafeEx",
  PRODUCT: "SAMMY",
  SUPPORT: "SafeEx Support",
} as const
